<template>
<div class="my-message">
    <!-- 页面内加载遮罩 -->
    <div v-if="isSending" class="sending-overlay">
        <div class="sending-content">
            <i class="el-icon-loading"></i>
            <p>{{ sendingText }}</p>
            <p v-if="currentSendProgress.total > 0" class="progress-text">
                已发送 {{ currentSendProgress.success }} / {{ currentSendProgress.total }} (失败 {{ currentSendProgress.failed }})
            </p>
            <el-button 
                type="danger" 
                size="small" 
                @click="handleCancelSending"
                :disabled="shouldStopSending"
            >
                {{ shouldStopSending ? '正在取消...' : '✕ 取消发送' }}
            </el-button>
        </div>
    </div>
    <!-- 分组管理弹窗 -->
    <el-dialog
        title="分组管理"
        :visible.sync="showGroupManageDialog"
        width="500px"
    >
        <div class="group-manage">
            <div class="create-group">
                <el-input 
                    v-model="newGroupName" 
                    placeholder="请输入新分组名称"
                    style="width: 300px; margin-right: 10px;"
                ></el-input>
                <el-button type="primary" size="small" @click="handleCreateGroup">创建分组</el-button>
            </div>
            <el-divider></el-divider>
            <div class="group-list">
                <div v-if="groupList.length === 0" class="empty-tip">
                    暂无分组
                </div>
                <div 
                    v-for="group in groupList" 
                    :key="group.id" 
                    class="group-item"
                >
                    <span>{{ group.name }} ({{ group.room_count || 0 }})</span>
                    <el-button 
                        type="danger" 
                        size="mini" 
                        plain
                        @click="deleteGroup(group.id)"
                    >
                        删除
                    </el-button>
                </div>
            </div>
        </div>
    </el-dialog>
    
    <!-- 移动到分组弹窗 -->
    <el-dialog
        title="移动到分组"
        :visible.sync="showMoveToGroupDialog"
        width="400px"
    >
        <div class="move-to-group">
            <p style="margin-bottom: 15px;">已将 {{ moveTargetContacts.length }} 个群聊选中</p>
            <el-form>
                <el-form-item label="目标分组">
                    <el-select 
                        v-model="selectedGroupForMove" 
                        placeholder="请选择目标分组"
                        style="width: 100%;"
                        multiple
                    >
                        <el-option
                            v-for="group in groupList"
                            :key="group.id"
                            :label="group.name"
                            :value="group.id"
                        ></el-option>
                       
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="showMoveToGroupDialog = false">取 消</el-button>
            <el-button type="primary" @click="confirmMoveToGroup">确 定</el-button>
        </span>
    </el-dialog>
    
    <template v-if="$store.state.member_id=='1'||$store.state.storePath.includes('my/message')">
        <el-tabs v-model="activeName" @tab-click="handleTabClick">
            <el-tab-pane label="消息编辑" name="first">
                <el-form ref="form" :model="messageInfo" label-width="100px" center v-loading="contacloading">
                    <!-- 定时发送设置 -->
                    <el-form-item label="定时发送">
                        <el-switch 
                            v-model="isScheduleSend" 
                            active-text="开启" 
                            inactive-text="关闭"
                            active-color="#409EFF"
                            inactive-color="#CCCCCC"
                            @change="handleScheduleSendChange"
                        ></el-switch>
                    </el-form-item>
                    <el-form-item v-if="isScheduleSend" label="发送时间">
                        <el-date-picker
                            v-model="sendTime"
                            type="datetime"
                            placeholder="选择发送时间"
                            style="width: 250px;"
                            :disabled="!isScheduleSend"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="消息类型" >
                        <el-select v-model="messageInfo.msgType" placeholder="请选择消息类型" style="width: 200px;">
                            <el-option
                                v-for="type in msgTypeList"
                                :key="type.id"
                                :label="type.name"
                                :value="type.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="文本消息" >
                        <el-input type="textarea" v-model="messageInfo.content"></el-input>
                    </el-form-item>
                    
                    <el-form-item label="图片消息" >
                        <el-upload
                            class="upload-image"
                            drag
                            :action="$axios.defaults.baseURL+'index.php?act=upload&op=image'"
                            :data="{store_id:this.$store.state.store_id}"
                            :headers="{'token':$store.state.token}"
                            name="image"
                            list-type="picture-card"
                            :on-success="upImgSuccess"
                            :on-preview="handleImgPreview"
                            :limit="9"
                            :on-remove="handleImgRemove"
                            :file-list="imageFileList"
                            multiple
                            >
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
                            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件</div>
                        </el-upload>
                        <!-- 图片预览弹窗 -->
                        <el-dialog
                            v-if="previewImageVisible"
                            :visible.sync="previewImageVisible"
                            title="图片预览"
                            top="15px"
                            class="image-preview-dialog"
                            width="800px"
                        >
                            <img :src="previewImageUrl" style="width: 100%;" />
                        </el-dialog>
                    </el-form-item>
                    <template >
                        <el-form-item label="上传文件" >
                            <el-upload
                                :action="$axios.defaults.baseURL+'index.php?act=upload&op=image'"
                                :data="{store_id:this.$store.state.store_id}"
                                :headers="{'token':$store.state.token}"
                                name="image"
                                :on-success="upFileSuccess"
                                :limit="9"
                                :on-remove="handleFileRemove"
                                :file-list="fileFileList"
                                multiple
                                >
                                <el-button size="mini" type="primary">点击上传</el-button>
                            </el-upload>
                        </el-form-item>
                      
                    </template>
                    <!-- 联系人选择区域 -->
                    <el-form-item label="选择联系人">
                        <div class="contact-selector-inline">
                            <!-- 好友分组 -->
                            <el-collapse v-model="activeCollapseNames">
                                <el-collapse-item name="friends">
                                    <template slot="title">
                                        好友 ({{ friendContacts.length }})
                                    </template>
                                    <!-- 好友列表全选按钮 -->
                                    <div style="margin-bottom: 10px; text-align: left;">
                                        <el-checkbox 
                                            v-model="selectAllFriends" 
                                            @change="handleSelectAllFriends"
                                            style="font-size: 13px;"
                                        >
                                            全选所有好友
                                        </el-checkbox>
                                    </div>
                                    <div class="contact-list">
                                        <el-checkbox-group v-model="selectedFriends">
                                            <el-checkbox 
                                                v-for="contact in friendContacts" 
                                                :key="contact.wxid" 
                                                :label="contact.wxid"
                                                class="contact-item"
                                            >
                                                <div class="contact-info">
                                                    <el-avatar 
                                                        :size="30" 
                                                        :src="contact.small_head_img_url || contact.smallHeadImgUrl" 
                                                        shape="square"
                                                    ></el-avatar>
                                                    <span class="contact-name">{{ contact.remark || contact.nick_name || contact.nickname || contact.wxid }}</span>
                                                </div>
                                            </el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                </el-collapse-item>
                                
                                <!-- 群聊分组 -->
                                <el-collapse-item name="groups">
                                    <template slot="title">
                                        群聊 ({{ filteredGroupContacts.length }})
                                    </template>
                                    <div class="group-filter" style="margin-bottom: 10px;">
                                        <div style="margin-bottom: 8px; font-size: 13px; color: #666;">选择信息分类：</div>
                                        <div class="parent-category-tags">
                                            <span
                                                v-for="parent in parentCategoryList"
                                                :key="parent.id"
                                                :class="['tag-item', { active: selectedParentCategoryId === parent.id }]"
                                                @click="handleParentCategoryChange(parent.id)"
                                            >
                                                {{ parent.name }}
                                            </span>
                                            <span
                                                v-if="parentCategoryList.length === 0"
                                                class="empty-tip"
                                            >
                                                暂无大组
                                            </span>
                                        </div>
                                        
                                        <el-select
                                            v-if="selectedParentCategoryId"
                                            v-model="selectedGroupId"
                                            placeholder="选择群分组"
                                            clearable
                                            size="small"
                                            style="width: 150px; margin-top: 10px;"
                                            @change="handleGroupFilterChange"
                                        >
                                            <el-option
                                                label="全部群分组"
                                                :value="null"
                                            ></el-option>
                                            <el-option
                                                v-for="group in filteredSubCategories"
                                                :key="group.id"
                                                :label="group.name"
                                                :value="group.id"
                                            ></el-option>
                                        </el-select>
                                    </div>
                                    <!-- 群聊列表全选按钮 -->
                                    <div style="margin-bottom: 10px; text-align: left;">
                                        <!-- <el-checkbox 
                                            v-model="selectAllGroups" 
                                            @change="handleSelectAllGroups"
                                            style="font-size: 13px;"
                                        >
                                            全选当前群聊列表
                                        </el-checkbox> -->
                                    </div>
                                    <div class="contact-list">
                                        <el-checkbox-group v-model="selectedGroups">
                                            <el-checkbox
                                                v-for="contact in filteredGroupContacts"
                                                :key="contact.wxid"
                                                :label="contact.wxid"
                                                class="contact-item"
                                            >
                                                <div class="contact-info">
                                                    <el-avatar
                                                        :size="30"
                                                        :src=" contact.small_head_img_url || contact.smallHeadImgUrl"
                                                        shape="square"
                                                    ></el-avatar>
                                                    <span class="contact-name">
                                                        {{ contact.remark || contact.nick_name || contact.nickName || contact.wxid }}
                                                    </span>
                                                </div>
                                            </el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                </el-collapse-item>
                            </el-collapse>
                            
                            <!-- 水印设置 -->
                            <div >
                                <el-switch 
                                    v-model="watermarkEnabled" 
                                    active-text="水印开启" 
                                    inactive-text="水印关闭"
                                    active-color="#409EFF"
                                    inactive-color="#CCCCCC"
                                    style="margin-right: 20px;"
                                ></el-switch>
                            </div>
                        </div>
                    </el-form-item>

                    <el-form-item>
                        <div style="text-align: center;">
                            <el-button size="mini" @click="clearMessageContent">清空内容</el-button>
                            <el-button type="primary" size="mini" @click="sendMessagesToSelectedContacts">发送消息</el-button>
                        </div>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="分组管理" name="third">
                <div class="group-management-page">
                    <!-- 新增父分组输入框 -->
                    <div v-if="showAddParentCategoryInput" class="add-parent-category">
                        <el-input 
                            v-model="newParentCategoryName" 
                            placeholder="请输入父分组名称"
                            style="width: 300px; margin-right: 10px;"
                            @keyup.enter="confirmAddParentCategory"
                        ></el-input>
                        <el-button type="primary" size="small" @click="confirmAddParentCategory">确认创建</el-button>
                        <el-button size="small" @click="toggleAddParentCategory">取消</el-button>
                    </div>
                    
                    <!-- 新增父分组按钮 -->
                    <div v-else class="add-parent-btn">
                        <el-button type="primary" size="small" @click="toggleAddParentCategory">新增父分组</el-button>
                        <el-button type="primary" size="small" @click="syncWechatFriends">同步微信好友信息</el-button>
                    </div>
                    
                    <!-- 父分组折叠面板 -->
                    <div class="parent-category-collapse">
                        <div v-if="parentCategoryList.length === 0" class="empty-tip">
                            暂无父分组，点击上方按钮添加
                        </div>
                        
                        <el-collapse v-else accordion>
                            <el-collapse-item 
                                v-for="parent in parentCategoryList" 
                                :key="'parent_' + parent.id"
                                :title="parent.name"
                            >
                                <template slot="title">
                                    <div class="collapse-header">
                                        <span class="parent-name">{{ parent.name }}</span>
                                        <span class="parent-actions">
                                            <el-button 
                                                type="primary" 
                                                size="mini" 
                                                plain
                                                @click.stop="openAddSubCategoryDialog(parent.id)"
                                                class="action-btn"
                                            >
                                                <i class="el-icon-plus"></i>
                                            </el-button>
                                            <el-button 
                                                type="danger" 
                                                size="mini" 
                                                plain
                                                @click.stop="removeParentCategory(parent.id)"
                                                class="action-btn"
                                            >
                                                <i class="el-icon-delete"></i>
                                            </el-button>
                                        </span>
                                    </div>
                                </template>
                                
                                <!-- 子分组折叠面板 -->
                                <el-collapse v-if="parent.children && parent.children.length > 0" accordion>
                                    <el-collapse-item 
                                        v-for="child in parent.children" 
                                        :key="'child_' + child.id"
                                        :title="child.name + ' (' + (child.room_count || 0) + '个群聊)'"
                                    >
                                        <template slot="title">
                                            <div class="collapse-header">
                                                <span class="child-name">{{ child.name }} ({{ child.room_count || 0 }})</span>
                                                <span class="child-actions">
                                                    <el-button 
                                                        type="primary" 
                                                        size="mini" 
                                                        plain
                                                        @click.stop="openAddRoomToCategoryDialog(child.id)"
                                                        class="action-btn"
                                                    >
                                                        <i class="el-icon-plus"></i>
                                                    </el-button>
                                                    <el-button 
                                                        type="danger" 
                                                        size="mini" 
                                                        plain
                                                        @click.stop="deleteSubCategory(child.id)"
                                                        class="action-btn"
                                                    >
                                                        <i class="el-icon-delete"></i>
                                                    </el-button>
                                                </span>
                                            </div>
                                        </template>
                                        <!-- 群聊列表 -->
                                        <div v-if="child.rooms && child.rooms.length > 0" class="room-list">
                                            <div 
                                                v-for="room in child.rooms" 
                                                :key="'room_' + room.id"
                                                class="room-item"
                                            >
                                                <el-avatar
                                                    :size="24"
                                                    :src="room.small_head_img_url || room.smallHeadImgUrl"
                                                    shape="square"
                                                ></el-avatar>
                                              
                                                <span class="room-name">{{  room.room_name || room.room_id }}</span>
                                                <el-button 
                                                    type="danger" 
                                                    size="mini" 
                                                    plain
                                                    @click.stop="removeRoomFromCategory(room.id)"
                                                    class="action-btn room-btn"
                                                >
                                                    <i class="el-icon-delete"></i>
                                                </el-button>
                                            </div>
                                        </div>
                                        <div v-else class="empty-room-tip">
                                            该子分组暂无群聊
                                        </div>
                                    </el-collapse-item>
                                </el-collapse>
                                
                                <div v-else class="empty-child-tip">
                                    该父分组暂无子分组，点击上方"+"按钮添加
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                </div>
            </el-tab-pane>
            
            <!-- 添加子分组弹窗 -->
            <el-dialog
                :title="'添加群分组（' + currentParentName + '）'"
                :visible.sync="showAddSubCategoryDialog"
                width="400px"
            >
                <div class="add-sub-category">
                    <el-form>
                        <el-form-item label="子分组名称">
                            <el-input 
                                v-model="newSubCategoryName" 
                                placeholder="请输入子分组名称"
                                style="width: 100%;"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="showAddSubCategoryDialog = false">取 消</el-button>
                    <el-button type="primary" @click="confirmAddSubCategory">确 定</el-button>
                </span>
            </el-dialog>
            
            <!-- 添加群聊到分组弹窗 -->
            <el-dialog
                :title="'添加群聊到分组（' + currentCategoryName + '）'"
                :visible.sync="showAddRoomDialog"
                width="600px"
            >
                <div class="add-room-to-category">
                    <!-- 搜索框 -->
                    <div class="search-box" style="margin-bottom: 15px;">
                        <el-input
                            v-model="roomSearchKeyword"
                            placeholder="搜索群聊名称"
                            prefix-icon="el-icon-search"
                            clearable
                            size="small"
                        ></el-input>
                    </div>
                    <p style="margin-bottom: 10px; font-size: 13px; color: #666;padding-left: 15px;">
                         <el-checkbox 
                            v-model="selectAllRooms" 
                            @change="handleSelectAllRooms"
                            style="font-size: 13px; "
                        >
                            全选
                        </el-checkbox>
                        选择要添加到分组的群聊（{{ filteredAvailableRooms.length }} / {{ availableRooms.length }}）：
                    </p>
                   
                    <el-checkbox-group v-model="selectedRoomsForAdd">
                        <div class="room-list-container">
                            <el-checkbox
                                v-for="room in filteredAvailableRooms"
                                :key="room.wxid"
                                :label="room.wxid"
                                class="contact-item"
                            >
                                <div class="contact-info">
                                    <el-avatar
                                        :size="30"
                                        :src="room.small_head_img_url || room.smallHeadImgUrl"
                                        shape="square"
                                    ></el-avatar>
                                    <span class="contact-name">
                                        {{ room.remark || room.nick_name || room.nickName || room.wxid }}
                                    </span>
                                </div>
                            </el-checkbox>
                        </div>
                    </el-checkbox-group>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="showAddRoomDialog = false">取 消</el-button>
                    <el-button type="primary" @click="confirmAddRoomsToCategory">确 定</el-button>
                </span>
            </el-dialog>
            
            <el-tab-pane label="消息历史" name="second">
                <div class="search-box">
                    <el-form :inline="true" :model="searchData" size="mini">
                        <el-form-item label="日期">
                            <el-date-picker
                                v-model="searchData.date"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :unlink-panels="true"
                                >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="消息类型">
                            <el-select v-model="searchData.msgType" class="small-select" placeholder="请选择">
                                <el-option label="全部" value=""></el-option>
                                <el-option
                                    v-for="type in msgTypeList"
                                    :key="type.id"
                                    :label="type.name"
                                    :value="type.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="搜索内容">
                            <el-input v-model="searchData.keyword" class="oe-el-input" placeholder="搜索消息内容"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="handleSearch">搜索</el-button>
                            <el-button @click="clearSearch">清空</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="his-list">
                    <div class="msg-item" v-for="(item,index) of messageList" :key="item.id || index">
                        <div class="item-top">
                            <span class="serial">序号: {{ (currentPage - 1) * pageSize + index + 1 }}</span>
                            <span class="msg-type">消息类型: {{ getMsgTypeName(item.msg_type) }}</span>
                            <span class="time">发布时间: {{ $hnwTools.formatDateTime(item.send_time) }} {{ item.send_time ? item.send_time.split(' ')[1] : '' }}</span>
                            <span class="publisher">发布人: {{ item.member_name }}</span>
                            <span class="send-status" :class="getSendStatusClass(item.send_status)">状态: {{ getSendStatusText(item.send_status) }}</span>
                        </div>
                        
                        <div v-if="item.image_content && item.image_content.length > 0" class="item-body">
                            <div class="section-title">图片消息:</div>
                            <div class="content-area">
                                <div class="image-grid">
                                    <el-image
                                    v-for="(img, idx) in item.image_content.split(',')"
                                        :preview-src-list="item.image_content.split(',')"
                                        :key="idx"
                                        :src="img"
                                        class="preview-image"
                                    ></el-image>
                                </div>
                            </div>
                        </div>
                        
                        <div v-if="item.text_content" class="item-body">
                            <div class="section-title">文字消息:</div>
                            <div class="content-area">
                                <div class="text-content">{{ item.text_content }}</div>
                            </div>
                        </div>
                        
                        <div v-if="item.file_content && item.file_content.length > 0" class="item-body">
                            <div class="section-title">文件消息:</div>
                            <div class="content-area">
                                <div class="file-list">
                                    <a
                                    v-for="(file, idx) in parseFileContent(item.file_content)"
                                        :download="file.name"
                                        :key="idx"
                                        :href="file.url"
                                        class="file-link"
                                    >
                                        <i class="el-icon-document"></i> {{ file.name }}
                                    </a>
                                    
                                </div>
                            </div>
                        </div>
                        
                        <div class="item-footer">
                            <el-button type="text" size="mini" @click="showReceivers(item)">查看接收方 ({{ parseReceivers(item.ext_data).length }})</el-button>
                            <el-button 
                                v-if="item.send_status ==0" 
                                type="success" 
                                size="mini" 
                                @click="resendMessage(item.id)"
                            >
                                更新状态
                            </el-button>
                        </div>
                    </div>
                </div>
                
                <!-- 接收方信息弹窗 -->
                <el-dialog
                    title="接收方信息"
                    :visible.sync="showReceiversDialogVisible"
                    width="700px"
                >
                    <div class="receivers-list">
                        <el-table :data="currentViewReceivers" border style="width: 100%">
                            <el-table-column prop="type" label="类型" width="80">
                                <template slot-scope="scope">
                                    {{ scope.row.type === 'friend' ? '好友' : '群聊' }}
                                </template>
                            </el-table-column>
                            <el-table-column label="信息分类" width="120">
                                <template slot-scope="scope">
                                    {{ scope.row.parentCategoryName || '-' }}
                                </template>
                            </el-table-column>
                            <el-table-column label="分组" width="120">
                                <template slot-scope="scope">
                                    {{ scope.row.categoryName || scope.row.groupName || '-' }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="name" label="名称"></el-table-column>
                            <!-- <el-table-column prop="wxid" label="wxid" width="180"></el-table-column> -->
                        </el-table>
                    </div>
                    <div v-if="currentViewReceivers.length === 0" class="empty-tip">暂无接收方信息</div>
                </el-dialog>
                
                <!-- 分页组件 -->
                <div class="pagination-container">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 50]"
                        :page-size="pageSize"
                        :total="total"
                        layout="total, sizes, prev, pager, next, jumper"
                    ></el-pagination>
                </div>
            </el-tab-pane>
        </el-tabs>

    </template>
</div>
</template>

<script>
/**
 * 将字符串转换为 URL 安全的 Base64 编码（适配阿里云水印等场景）
 * @param {string} str - 需要编码的字符串（支持中文、英文、Emoji等）
 * @returns {string} - URL 安全的 Base64 字符串
 */
function encodeUrlSafeBase64(str) {
  if (!str) return '';

  // 1. 解决中文/特殊字符乱码问题：使用 TextEncoder 将字符串转为 UTF-8 字节流
  const encoder = new TextEncoder();
  const uint8Array = encoder.encode(str);
  
  // 2. 将字节流转换为二进制字符串，供 btoa 使用
  // btoa 原生只支持 ASCII 字符，直接传中文会报错，所以需要先转成字节对应的单字符
  let binaryString = '';
  uint8Array.forEach(byte => {
    binaryString += String.fromCharCode(byte);
  });

  // 3. 进行标准的 Base64 编码
  let base64 = btoa(binaryString);

  // 4. 转换为 URL 安全格式（阿里云要求的标准操作）
  return base64
    .replace(/\+/g, '-')  // 将加号 + 替换为短划线 -
    .replace(/\//g, '_')  // 将正斜线 / 替换为下划线 _
    .replace(/=+$/, '');  // 去掉尾部的等号 =
}
export default {
    data(){
        return{

            messageInfo:{
                content:"",
                file:"",
                type:"文本",
                fileName:"",
                msgType: ""
            },

            activeName:"first",
            messageList:[],
            fileList:[],
            imgList:[],
            // 用于 el-upload 组件的 file-list 绑定
            imageFileList: [],
            fileFileList: [],
            // 消息类型列表
            msgTypeList: [],
            // 分页相关
            currentPage: 1,
            pageSize: 10,
            total: 0,
            // 搜索相关
            searchData: {
                date: '',
                msgType: '',
                keyword: ''
            },
            // 图片预览相关
            previewImageVisible: false,
            previewImageUrl: '',
            // 存储发送消息的返回信息，用于撤回功能
            sentMessages: [],
            // 存储当前发送的接收方信息
            currentReceivers: [],
            // 查看接收方信息弹窗
            showReceiversDialogVisible: false,
            // 当前查看的接收方列表
            currentViewReceivers: [],
            // 新增：控制发送中断标志
            shouldStopSending: false,
            // 新增：页面内加载状态
            isSending: false,
            sendingText: '正在发送中...',
            
            // 联系人选择相关数据
            activeCollapseNames: ['friends', 'groups'], // 默认展开所有分组
            allContacts: [], // 所有联系人信息
            friendContacts: [], // 好友联系人
            groupContacts: [], // 群聊联系人
            selectedFriends: [], // 选中的好友
            selectedGroups: [], // 选中的群聊
            selectAllFriends: false, // 是否全选好友
            selectAllGroups: false, // 是否全选群聊
            filteredFriends: [], // 过滤后的好友列表
            filteredChatrooms: [], // 过滤后的群聊列表
            filteredGroupContacts: [], // 过滤后的群聊联系人（根据分组筛选）
            watermarkEnabled: false, // 是否添加水印，默认开启
            
            // 分组管理相关数据
            groupList: [], // 分组列表（子分组）
            selectedGroupId: null, // 当前选中的分组ID（用于筛选）
            selectedGroupForMove: null, // 当前选中的分组ID（用于移动联系人）
            defaultCategoryId: null, // 默认分组ID
            showGroupManageDialog: false, // 是否显示分组管理弹窗
            showMoveToGroupDialog: false, // 是否显示移动到分组弹窗
            newGroupName: '', // 新建分组名称
            moveTargetContacts: [], // 要移动的目标联系人列表
            
            // 父分组相关数据
            parentCategoryList: [], // 父分组列表
            expandedParentCategories: [], // 展开的父分组ID列表
            expandedSubCategories: [], // 展开的子分组ID列表
            newParentCategoryName: '', // 新父分组名称
            showAddParentCategoryInput: false, // 是否显示新增父分组输入框
            
            // 级联选择相关
            selectedParentCategoryId: null, // 选中的父分组ID
            filteredSubCategories: [], // 根据父分组筛选的子分组列表
            
            // 定时发送相关
            sendTime: '', // 定时发送时间
            isScheduleSend: false, // 是否定时发送

            // 当前发送消息记录ID（用于取消和失败时更新状态）
            currentMessageRecordId: null,

            // 发送进度
            currentSendProgress: {
                total: 0,
                success: 0,
                failed: 0
            },
            
            // 添加子分组弹窗相关
            showAddSubCategoryDialog: false, // 是否显示添加子分组弹窗
            newSubCategoryName: '', // 新子分组名称
            currentParentId: null, // 当前操作的父分组ID
            currentParentName: '', // 当前操作的父分组名称
            
            // 添加群聊到分组弹窗相关
            showAddRoomDialog: false, // 是否显示添加群聊弹窗
            availableRooms: [], // 可添加的群聊列表（未分配到当前分组的）
            selectedRoomsForAdd: [], // 选中要添加的群聊
            selectAllRooms: false, // 是否全选群聊
            currentCategoryId: null, // 当前操作的子分组 ID
            currentCategoryName: '', // 当前操作的子分组名称
            roomSearchKeyword: '', // 群聊搜索关键词
            contacloading: false  // 页面加载状态
        }
    },
    
    methods:{
        
        // 初始化联系人列表（页面加载时调用）
        async initContactList() {
            try {
                this.contacloading = true
                // 获取联系人列表
                let res = await this.$apiGewe.getUserList({})
                
                // 过滤好友和群聊
                this.filteredFriends = res.data.friends.filter(friend => {
                    return friend.startsWith('wxid_') || friend.startsWith('li')
                })
                this.filteredChatrooms = res.data.chatrooms
                
                // 分批获取联系人详细信息
                await this.fetchContactDetails()
                
                // 初始化 filteredGroupContacts（默认显示所有群聊）
                this.filteredGroupContacts = [...this.groupContacts]
                
                // console.log('✅ 联系人列表初始化完成')
                // console.log('✅ groupContacts:', this.groupContacts)
                // console.log('✅ filteredGroupContacts:', this.filteredGroupContacts)
                this.contacloading = false
            } catch (error) {
                this.contacloading = false
                console.error('初始化联系人列表失败：', error)
            }
        },
        

        
        // 获取上次选择的联系人
        async getLastSelectedContacts() {
            try {
                // 获取上次选择的好友
                const lastSelectedFriendsRes = await this.$api.getCommData({
                    k: 'last_mine_wxids'
                });
                
                // 获取上次选择的群聊
                const lastSelectedGroupsRes = await this.$api.getCommData({
                    k: 'last_room_wxids'
                });
                console.log("lastSelectedFriendsRes",lastSelectedFriendsRes);
                
                // 如果有上次选择的联系人，则使用上次的选择，不再默认全选
                if (lastSelectedFriendsRes && lastSelectedFriendsRes.length>0) {
                    // 过滤掉已经不存在的联系人
                    this.selectedFriends = lastSelectedFriendsRes[0].value.split(",")
                } else {
                    // 如果没有上次选择的记录，则默认不选中任何好友
                    this.selectedFriends = [];
                }
                
                if (lastSelectedGroupsRes && lastSelectedGroupsRes.length>0) {
                    // 过滤掉已经不存在的群聊
                    this.selectedGroups = lastSelectedGroupsRes[0].value.split(',')
                } else {
                    // 如果没有上次选择的记录，则默认不选中任何群聊
                    this.selectedGroups = [];
                }
                
                // 更新全选状态
                this.selectAllFriends = this.selectedFriends.length === this.friendContacts.length && this.friendContacts.length > 0;
                this.selectAllGroups = this.selectedGroups.length === this.groupContacts.length && this.groupContacts.length > 0;
            } catch (error) {
                console.error('获取上次选择的联系人失败：', error);
                // 如果获取失败，则默认不选中任何联系人
                this.selectedFriends = [];
                this.selectedGroups = [];
                this.selectAllFriends = false;
                this.selectAllGroups = false;
            }
        },
        
        // 保存当前选择的联系人
        async saveCurrentSelectedContacts() {
            try {
                // 保存当前选择的好友
                // await this.$api.setCommData({
                //     k: 'last_mine_wxids',
                //     v: this.selectedFriends.join()
                // });
                
                // // 保存当前选择的群聊
                // await this.$api.setCommData({
                //     k: 'last_room_wxids',
                //     v: this.selectedGroups.join()
                // });
            } catch (error) {
                console.error('保存当前选择的联系人失败：', error);
            }
        },
        
        // 分批获取联系人详细信息
        async fetchContactDetails() {
            // 获取好友详细信息
            this.friendContacts = await this.fetchBatchContactDetails(this.filteredFriends, '好友')
            
            // 获取群聊详细信息
            this.groupContacts = await this.fetchBatchContactDetails(this.filteredChatrooms, '群聊')
            // console.log("this.friendContacts",this.friendContacts);
            // console.log("this.groupContacts",this.groupContacts);
        },
        
        // 分批获取联系人详细信息（每批不超过20个）
        async fetchBatchContactDetails(wxids, type) {
            let contacts = []
            const batchSize = 20 // 每批最多20
            
            for (let i = 0; i < wxids.length; i += batchSize) {
                const batch = wxids.slice(i, i + batchSize)
                try {
                    const res = await this.$api.queryContacts({
                        wxids: JSON.stringify(batch)
                    })
                    // const res = await this.$apiGewe.getDetailInfo({
                    //     wxids: batch
                    // })
                    
                    if (res ) {
                        // wxid: contact.userName, 用之前接口就得用这个
                        const batchContacts = res.map(contact => ({
                            ...contact,
                            type: type === '好友' ? 'friend' : 'group',
                            wxid: contact.wxid || contact.userName || contact.user_name,
                            category_id: contact.category_id
                        }))
                        contacts = contacts.concat(batchContacts)
                    }
                } catch (error) {
                    console.error(`获取${type}详细信息失败：`, error)
                }
            }
            
            return contacts
        },
        
        // 全选/取消全选好友
        handleSelectAllFriends(val) {
            if (val) {
                this.selectedFriends = this.friendContacts.map(contact => contact.wxid)
            } else {
                this.selectedFriends = []
            }
        },
        
        // 全选/取消全选群聊（只选中当前显示的群聊列表）
        handleSelectAllGroups(val) {
            console.log("全选群聊操作");
            
            if (val) {
                this.selectedGroups = this.filteredGroupContacts.map(contact => contact.wxid)
            } else {
                this.selectedGroups = []
            }
        },
        
        // 刷新群聊分组映射（获取所有已设置分组的群聊，更新group_names，支持多对多）
        async refreshGroupContactsMapping() {
            try {
                const roomRes = await this.$api.getRoomList({})
                const roomList = Array.isArray(roomRes) ? roomRes : []
                
                // 构建群聊ID到分组名称列表的映射（支持多对多）
                const roomToGroupsMap = {}
                roomList.forEach(room => {
                    if (room.category_id) {
                        const group = this.groupList.find(g => g.id === room.category_id)
                        if (group) {
                            if (!roomToGroupsMap[room.room_id]) {
                                roomToGroupsMap[room.room_id] = []
                            }
                            if (!roomToGroupsMap[room.room_id].includes(group.name)) {
                                roomToGroupsMap[room.room_id].push(group.name)
                            }
                        }
                    }
                })
                
                // 根据当前筛选状态更新列表
                if (this.selectedGroupId) {
                    const roomIds = roomList
                        .filter(r => r.category_id === this.selectedGroupId)
                        .map(r => r.room_id)
                    this.filteredGroupContacts = this.groupContacts.filter(contact =>
                        roomIds.includes(contact.wxid)
                    ).map(contact => ({
                        ...contact,
                        group_names: roomToGroupsMap[contact.wxid] || []
                    }))
                } else {
                    this.filteredGroupContacts = this.groupContacts.map(contact => ({
                        ...contact,
                        group_names: roomToGroupsMap[contact.wxid] || []
                    }))
                }
            } catch (error) {
                console.error('刷新群聊分组映射失败：', error)
            }
        },
        
        // 根据分组筛选群聊
        async handleGroupFilterChange(categoryId) {
            // 重置群聊选中状态和全选状态
            this.selectedGroups = []
            this.selectAllGroups = false
            
            // 如果选择了大组，只显示该大组下的群聊
            if (this.selectedParentCategoryId && !categoryId) {
                // 获取该大组下所有子分组的群聊
                const allRoomIds = []
                for (const child of this.filteredSubCategories) {
                    const rooms = await this.getRoomsBySubCategory(child.id)
                    rooms.forEach(room => allRoomIds.push(room.room_id))
                }
                
                // 获取所有已设置分组的群聊，用于显示分组名称
                try {
                    const allRoomRes = await this.$api.getRoomList({})
                    const allRoomList = Array.isArray(allRoomRes) ? allRoomRes : []
                    
                    // 创建群聊ID到分组名称列表的映射（支持多对多）
                    const roomToGroupsMap = {}
                    allRoomList.forEach(room => {
                        if (room.category_id) {
                            const group = this.groupList.find(g => g.id === room.category_id)
                            if (group) {
                                if (!roomToGroupsMap[room.room_id]) {
                                    roomToGroupsMap[room.room_id] = []
                                }
                                if (!roomToGroupsMap[room.room_id].includes(group.name)) {
                                    roomToGroupsMap[room.room_id].push(group.name)
                                }
                            }
                        }
                    })
                    
                    // 根据群聊ID过滤出详细信息
                    this.filteredGroupContacts = this.groupContacts.filter(contact => 
                        allRoomIds.includes(contact.wxid)
                    ).map(contact => ({
                        ...contact,
                        group_names: roomToGroupsMap[contact.wxid] || []
                    }))
                } catch (error) {
                    console.error('获取大组群聊列表失败：', error)
                    this.filteredGroupContacts = []
                }
                return
            }
            
            if (!categoryId) {
                // 显示全部群聊
                // 获取所有已设置分组的群聊，用于显示分组名称
                try {
                    const roomRes = await this.$api.getRoomList({})
                    const roomList = Array.isArray(roomRes) ? roomRes : []
                    
                    // 创建群聊ID到分组名称列表的映射（支持多对多）
                    const roomToGroupsMap = {}
                    roomList.forEach(room => {
                        if (room.category_id) {
                            const group = this.groupList.find(g => g.id === room.category_id)
                            if (group) {
                                if (!roomToGroupsMap[room.room_id]) {
                                    roomToGroupsMap[room.room_id] = []
                                }
                                if (!roomToGroupsMap[room.room_id].includes(group.name)) {
                                    roomToGroupsMap[room.room_id].push(group.name)
                                }
                            }
                        }
                    })
                    
                    // 为每个群聊添加分组名称列表
                    this.filteredGroupContacts = this.groupContacts.map(contact => ({
                        ...contact,
                        group_names: roomToGroupsMap[contact.wxid] || []
                    }))
                } catch (error) {
                    console.error('获取群聊分组映射失败：', error)
                    this.filteredGroupContacts = [...this.groupContacts]
                }
            } else {
                // 调用API获取该分组下的群聊列表
                try {
                    const res = await this.$api.getRoomList({ category_id: categoryId })
                    if (res) {
                        // 获取分组下的群聊ID列表
                        const roomIds = Array.isArray(res) ? res.map(r => r.room_id) : []
                        
                        // 获取所有已设置分组的群聊，用于构建完整的分组名称映射
                        const allRoomRes = await this.$api.getRoomList({})
                        const allRoomList = Array.isArray(allRoomRes) ? allRoomRes : []
                        
                        // 创建群聊ID到分组名称列表的映射（支持多对多）
                        const roomToGroupsMap = {}
                        allRoomList.forEach(room => {
                            if (room.category_id) {
                                const group = this.groupList.find(g => g.id === room.category_id)
                                if (group) {
                                    if (!roomToGroupsMap[room.room_id]) {
                                        roomToGroupsMap[room.room_id] = []
                                    }
                                    if (!roomToGroupsMap[room.room_id].includes(group.name)) {
                                        roomToGroupsMap[room.room_id].push(group.name)
                                    }
                                }
                            }
                        })
                        
                        // 根据群聊ID过滤出详细信息
                        this.filteredGroupContacts = this.groupContacts.filter(contact => 
                            roomIds.includes(contact.wxid)
                        ).map(contact => ({
                            ...contact,
                            group_names: roomToGroupsMap[contact.wxid] || []
                        }))
                        
                        // 默认选中该子分组下的所有群聊
                        this.selectedGroups = [...roomIds]
                        this.selectAllGroups = true
                    } else {
                        this.filteredGroupContacts = []
                    }
                } catch (error) {
                    console.error('获取分组群聊列表失败：', error)
                    this.filteredGroupContacts = []
                }
            }
        },
        
        // 发送消息到选中的联系人
        async sendMessagesToSelectedContacts() {
            // 校验是否有选中的联系人或群聊
            if (this.selectedFriends.length === 0 && this.selectedGroups.length === 0) {
                this.$message.warning('请先选择要发送消息的好友或群聊')
                return
            }

            // 收集所有需要发送消息的联系人
            let allContactsToSend = [];
            this.currentReceivers = [];
            
            // 添加选中的好友
            if (this.selectedFriends.length > 0) {
                const selectedFriendContacts = this.friendContacts.filter(contact => 
                    this.selectedFriends.includes(contact.wxid)
                )
                allContactsToSend = allContactsToSend.concat(selectedFriendContacts);
                selectedFriendContacts.forEach(friend => {
                    this.currentReceivers.push({
                        type: 'friend',
                        wxid: friend.wxid,
                        name: friend.remark || friend.nick_name || friend.nickname || friend.wxid,
                        groupName: '好友',
                        parentCategoryId: null,
                        categoryId: null,
                        parentCategoryName: null,
                        categoryName: null
                    })
                })
            }
            
            // 添加选中的群聊
            if (this.selectedGroups.length > 0) {
                const selectedGroupContacts = this.groupContacts.filter(contact => 
                    this.selectedGroups.includes(contact.wxid)
                )
                allContactsToSend = allContactsToSend.concat(selectedGroupContacts);
                
                // 获取父分组名称
                const parentCategory = this.parentCategoryList.find(p => p.id === this.selectedParentCategoryId);
                const parentCategoryName = parentCategory ? parentCategory.name : null;
                
                // 获取子分组名称
                const subCategory = this.filteredSubCategories.find(s => s.id === this.selectedGroupId);
                const categoryName = subCategory ? subCategory.name : null;
                
                selectedGroupContacts.forEach(group => {
                    this.currentReceivers.push({
                        type: 'group',
                        wxid: group.wxid,
                        name: group.remark || group.nick_name || group.nickName || group.wxid,
                        groupName: (group.group_names && group.group_names.length > 0) ? group.group_names.join(',') : '默认分组',
                        parentCategoryId: this.selectedParentCategoryId,
                        categoryId: this.selectedGroupId,
                        parentCategoryName: parentCategoryName,
                        categoryName: categoryName
                    })
                })
            }

            // 判断是否开启定时发送
            if (this.isScheduleSend && this.sendTime) {
                // 定时发送：跳过发送逻辑，直接保存记录
                await this.saveMessageHistory()
                this.clearMessageContent()
                this.$suMsg('定时消息已保存')
                return
            }

            // 先发送初始化消息获取消息记录ID
            let messageRecordId = null;
            try {
                const initRes = await this.$api.sendWxMsg({
                    msg_type: this.messageInfo.msgType,
                    text_content: '初始化消息',
                })
                console.log("初始化消息返回:", initRes);
                if (initRes && initRes.id) {
                    messageRecordId = initRes.id;
                    console.log("消息记录ID:", messageRecordId);
                    // 将消息ID保存到data中，用于取消和失败时更新状态
                    this.currentMessageRecordId = messageRecordId;
                } else {
                    return
                }
            } catch (error) {
                console.error('初始化消息失败:', error)
                this.$erMsg('初始化消息失败')
                return
            }
            
            // 显示页面内加载状态
            this.isSending = true
            this.sendingText = '正在发送中...'
            
            // 清空之前的发送记录和中断标志
            this.sentMessages = []
            this.shouldStopSending = false
            
            // 初始化发送进度
            this.currentSendProgress = {
                total: allContactsToSend.length,
                success: 0,
                failed: 0
            }
            
            // 记录发送状态
            let sendStatus = 1; // 1=已发送（默认）
            
            const sendMessagesToContacts = async (contacts) =>{
                // 随机延迟函数：延迟 3~5 秒
                const randomDelay = () => {
                    const delay = Math.floor(Math.random() * 3000) + 3000; // 3000ms ~ 5000ms
                    return new Promise(resolve => setTimeout(resolve, delay));
                };
                const randomDelay1000 = () => {
                    const delay = Math.floor(Math.random() * 1000) + 2000; 
                    return new Promise(resolve => setTimeout(resolve, delay));
                };

                // 获取第一个联系人作为基准
                const firstContact = contacts.length > 0 ? contacts[0] : null;

                // 遍历每个联系人
                for (const contact of contacts) {
                    // 检查是否需要中断
                    if (this.shouldStopSending) {
                        console.log('🚫 用户取消发送，中断后续消息发送')
                        break
                    }
                    
                    console.log(`📌 开始处理联系人: ${contact.wxid}`);
                    try {
                        // 检查是否需要中断
                        if (this.shouldStopSending) {
                            console.log('🚫 用户取消发送，中断当前联系人消息发送')
                            break
                        }
                        
                        // 判断是否是第一个联系人
                        const isFristContact = firstContact && contact.wxid === firstContact.wxid;
                        
                        // === 第一个接口：sendMsg ===
                        if(this.messageInfo.content){

                            let msgResult = await this.$apiGewe.sendMsg({
                                toWxid: contact.wxid,
                                ...this.messageInfo
                            });
                            console.log(`✅ ${contact.wxid} - sendMsg 发送成功`);
                            
                            // 存储发送结果用于撤回
                            if(msgResult && msgResult.data) {
                                this.sentMessages.push({
                                    ...msgResult.data,
                                    type: 'text'
                                })
                            }
                            
                            await randomDelay1000(); // 延迟 3~5 秒
                        }

                        // === 第二个接口：sendFileMsg ===
                        console.log("📁 文件列表长度:", this.fileFileList.length);
                        console.log("📁 文件列表内容:", this.fileFileList);
                        if(this.fileFileList.length>0){
                            for (let index = 0; index < this.fileFileList.length; index++) {
                                // 检查是否需要中断
                                if (this.shouldStopSending) {
                                    console.log('🚫 用户取消发送，中断文件消息发送')
                                    break
                                }
                                const fileItem = this.fileFileList[index];
                                // 获取文件URL，支持多种数据结构
                                const fileUrl = fileItem.response?.data?.url || fileItem.url || fileItem.response?.url || '';
                                const fileName = fileItem.name || fileItem.fileName || 'unknown';
                                
                                if (!fileUrl) {
                                    console.error('❌ 文件URL为空，跳过该文件:', fileItem);
                                    continue;
                                }
                                
                                let fileResult = await this.$apiGewe.sendFileMsg({
                                    toWxid: contact.wxid,
                                    fileUrl: fileUrl,
                                    fileName: fileName
                                });
                                console.log(`✅ ${contact.wxid} - sendFileMsg 发送成功`);
                                
                                // 存储发送结果用于撤回
                                if(fileResult && fileResult.data) {
                                    this.sentMessages.push({
                                        ...fileResult.data,
                                        type: 'file'
                                    })
                                }
                                
                                await randomDelay1000(); // 延迟 3~5 秒
                            }
                        }

                        // === 第三个接口：sendImgMsg ===
                        console.log("🖼️ 图片列表长度:", this.imageFileList.length);
                        console.log("🖼️ 图片列表内容:", this.imageFileList);
                        if(this.imageFileList.length>0){
                            for (let index = 0; index < this.imageFileList.length; index++) {
                                // 检查是否需要中断
                                if (this.shouldStopSending) {
                                    console.log('🚫 用户取消发送，中断图片消息发送')
                                    break
                                }

                                const fileItem = this.imageFileList[index];
                                console.log("contact",contact);
                                
                                // 获取图片URL，支持多种数据结构
                                const imgUrl = fileItem.response?.data?.url || fileItem.url || fileItem.response?.url || '';
                                
                                if (!imgUrl) {
                                    console.error('❌ 图片URL为空，跳过该图片:', fileItem);
                                    continue;
                                }
                                
                                let watermarkEss = "";
                                if (this.watermarkEnabled) {
                                    let base64Text = encodeUrlSafeBase64(contact.remark || contact.nick_name || contact.nickName || contact.nickname || contact.wxid);
                                    watermarkEss = `?x-oss-process=image/watermark,text_${base64Text},color_EEEEEE,size_28,rotate_45,fill_1,t_50,g_center,shadow_0,padx_80,pady_40`;
                                }
                              
                                 let imgResult = await this.$apiGewe.sendImgMsg({
                                    toWxid: contact.wxid,
                                    imgUrl: imgUrl + watermarkEss
                                });
                                // 存储发送结果用于撤回
                                if(imgResult && imgResult.data) {
                                    this.sentMessages.push({
                                        ...imgResult.data,
                                        type: 'image'
                                    })
                                }
                                
                                await randomDelay1000(); // 延迟 3~5 秒
                            }
                            
                            console.log(`✅ ${contact.wxid} - sendImgMsg 发送成功`);
                        }

                        // 当前联系人全部完成，延迟 3~5 秒再处理下一个联系人
                        if (contact !== contacts[contacts.length - 1]) {
                            console.log(`⏳ 联系人 ${contact.wxid} 完成，等待 3~5 秒进入下一个联系人...`);
                            await randomDelay();
                        }

                        // 更新进度：当前联系人发送成功
                        this.currentSendProgress.success++;

                    } catch (error) {
                        console.error(`❌ 联系人 ${contact.wxid} 执行失败：`, error);
                        // 更新进度：当前联系人发送失败
                        this.currentSendProgress.failed++;
                        // 标记发送状态为失败
                        sendStatus = 2;
                        // 可选择继续下一个联系人，或 throw 终止流程
                        // throw error; // 若想中断，取消注释
                    }
                }
                console.log('🎉 所有消息发送完成！');
            }
            
            // 使用选中的联系人发送消息
            try {
                console.log("this.selectedFriends",this.selectedFriends);
                console.log("this.selectedGroupContacts",this.selectedGroupContacts);
                
                // 发送消息
                if (!this.shouldStopSending && allContactsToSend.length > 0) {
                    this.sendingText = '正在发送消息...'
                    await sendMessagesToContacts(allContactsToSend);
                }
            } catch (error) {
                console.error('发送消息错误：', error)
                sendStatus = 2; // 发送失败
            }
            
            // 关闭页面内加载状态
            this.isSending = false
            
            // 根据是否中断来决定后续操作
            if (this.shouldStopSending) {
                // 被中断的情况，直接撤回已发送的消息
                sendStatus = 3; // 已取消
                if (this.sentMessages.length > 0) {
                    this.revokeAllMessages()
                } else {
                    this.$warMsg('发送已取消')
                }
            } else {
                // 正常完成，存储消息历史记录
                await this.saveMessageHistory(messageRecordId)
                // 显示成功信息
                this.$suMsg('发送完成')
            }

            // 更新消息状态（在清空内容之前调用）
            if (messageRecordId) {
                await this.updateMessageStatus(messageRecordId, sendStatus)
            }

            // 清空用户输入的消息内容
            this.clearMessageContent()

            // 清理当前消息记录 ID
            this.currentMessageRecordId = null;
        },
        
        // 保存消息历史记录
        async saveMessageHistory(messageRecordId = null) {
            console.log("好像用不上了");
            
            return
            try {
                // 构建消息内容，将撤回数据和接收方信息都存储到 ext_data 中
                const extData = {
                    sentMessages: this.sentMessages,
                    receivers: this.currentReceivers,
                    parentCategoryId: this.selectedParentCategoryId,
                    categoryId: this.selectedGroupId,
                    parentCategoryName: this.parentCategoryList.find(p => p.id === this.selectedParentCategoryId)?.name || null,
                    categoryName: this.filteredSubCategories.find(s => s.id === this.selectedGroupId)?.name || null
                }
                
                // 构建定时发送相关参数
                const isScheduled = this.isScheduleSend && this.sendTime ? 1 : 0;
                const scheduledTime = isScheduled ? new Date(this.sendTime).getTime() : null;
                const sendGroup = this.currentReceivers.map(r => r.wxid).join(',');
                
                const messageData = {
                    id: messageRecordId, // 如果有初始化消息ID，传入用于更新
                    msg_type: this.messageInfo.msgType || '其他',
                    text_content: this.messageInfo.content || '',
                    image_content: this.imageFileList.length > 0 ? this.imageFileList.map(item => item.response.data.url).join(',') : '',
                    file_content: this.fileFileList.length > 0 ? this.fileFileList.map(item => item.response.data.url + '|' + item.name).join(',') : '',
                    ext_data: JSON.stringify(extData),
                    is_scheduled: isScheduled,
                    scheduled_time: scheduledTime,
                    send_group: sendGroup
                }
                
                if (messageRecordId) {
                    // 如果有初始化消息ID，调用更新接口
                    await this.$api.updateWxMsg(messageData)
                    console.log('✅ 消息历史记录更新成功')
                } else {
                    // 没有初始化消息ID，调用发送接口创建新记录
                    await this.$api.sendWxMsg(messageData)
                    console.log('✅ 消息历史记录保存成功')
                }
            } catch (error) {
                console.error('❌ 消息历史记录保存/更新失败:', error)
            }
        },

        // 更新消息状态
        async updateMessageStatus(messageRecordId, sendStatus) {
            try {
                // 构建消息内容，将撤回数据和接收方信息都存储到 ext_data 中
                const extData = {
                    sentMessages: this.sentMessages,
                    receivers: this.currentReceivers,
                    parentCategoryId: this.selectedParentCategoryId,
                    categoryId: this.selectedGroupId,
                    parentCategoryName: this.parentCategoryList.find(p => p.id === this.selectedParentCategoryId)?.name || null,
                    categoryName: this.filteredSubCategories.find(s => s.id === this.selectedGroupId)?.name || null
                }
                
                // 构建定时发送相关参数
                const isScheduled = this.isScheduleSend && this.sendTime ? 1 : 0;
                const scheduledTime = isScheduled ? new Date(this.sendTime).getTime() : null;
                const sendGroup = this.currentReceivers.map(r => r.wxid).join(',');
                
                const updateData = {
                    id: messageRecordId,
                    msg_type: this.messageInfo.msgType || '其他',
                    text_content: this.messageInfo.content || '',
                    image_content: this.imageFileList.length > 0 ? this.imageFileList.map(item => item.response.data.url).join(',') : '',
                    file_content: this.fileFileList.length > 0 ? this.fileFileList.map(item => item.response.data.url + '|' + item.name).join(',') : '',
                    ext_data: JSON.stringify(extData),
                    is_scheduled: isScheduled,
                    scheduled_time: scheduledTime,
                    send_group: sendGroup,
                    send_status: sendStatus
                }
                
                await this.$api.updateWxMsg(updateData)
                console.log('✅ 消息状态更新成功，状态:', sendStatus)
            } catch (error) {
                console.error('❌ 消息状态更新失败:', error)
            }
        },

        // 重新发送消息（仅更新状态为已发送）
        async resendMessage(messageId) {
            try {
                await this.$api.updateWxMsg({
                    id: messageId,
                    send_status: 1
                })
                this.$suMsg('消息已标记为已发送')
                // 刷新消息列表
                this.getAllList()
            } catch (error) {
                console.error('❌ 重新发送消息失败:', error)
                this.$erMsg('操作失败')
            }
        },
        
        // 清空消息内容
        clearMessageContent() {
            
            this.messageInfo.content = ''
            this.messageInfo.msgType = ''
            this.imageFileList = []
            this.fileFileList = []
            this.sentMessages = []
            this.currentReceivers = []
            // 清空定时发送相关参数
            this.sendTime = ''
            this.isScheduleSend = false
            // 清空分组选择参数
            this.selectedParentCategoryId = null
            this.selectedGroupId = null
        },
        
        // 图片预览处理
        handleImgPreview(file) {
            // 获取预览图片的URL
            const imgUrl = file.response?.data?.url || file.url || ''
            if (imgUrl) {
                this.previewImageUrl = imgUrl
                this.previewImageVisible = true
            }
        },
        
        // 图片移除处理
        handleImgRemove(file, fileList) {
            this.imageFileList = fileList
        },
        
        // 文件移除处理
        handleFileRemove(file, fileList) {
            this.fileFileList = fileList
        },
        

        
        // 处理取消发送
        handleCancelSending() {
            this.$confirm('确定要取消发送吗？将会中断后续消息并撤回已发送的消息。', '取消发送', {
                confirmButtonText: '确定取消',
                cancelButtonText: '继续发送',
                type: 'warning'
            }).then(async () => {
                this.shouldStopSending = true
                this.sendingText = '正在取消发送...'
                console.log('🚫 用户确认取消发送')
                
                // 如果有当前发送的消息记录ID，立即更新状态为已取消
                if (this.currentMessageRecordId) {
                    try {
                        await this.$api.updateWxMsg({
                            id: this.currentMessageRecordId,
                            send_status: 3
                        })
                        console.log('✅ 消息状态已更新为已取消')
                    } catch (error) {
                        console.error('❌ 更新消息状态失败:', error)
                    }
                }
            }).catch(() => {
                console.log('🚀 用户选择继续发送')
            })
        },
        
        // 撤回所有已发送的消息
        async revokeAllMessages() {
            const revokeLoading = this.$loading({
                lock: true,
                text: '正在撤回消息...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            
            let successCount = 0
            let failCount = 0
            
            for (const message of this.sentMessages) {
                try {
                    console.log('正在撤回消息:', message)
                    
                    // 调用撤回接口，直接传入message对象
                    await this.$apiGewe.revokeMsg(message)
                    
                    successCount++
                    console.log(`✅ 撤回成功: ${message.toWxid || 'unknown'} - ${message.type}`)
                    
                    // 撤回间隔延迟
                    await new Promise(resolve => setTimeout(resolve, 1000))
                    
                } catch (error) {
                    failCount++
                    console.error(`❌ 撤回失败: ${message.toWxid || 'unknown'} - ${message.type}`, error)
                }
            }
            
            revokeLoading.close()
            
            // 显示撤回结果
            if (failCount === 0) {
                this.$suMsg(`撤回完成！成功撤回 ${successCount} 条消息`)
            } else {
                this.$warMsg(`撤回完成！成功 ${successCount} 条，失败 ${failCount} 条`)
            }
            
            // 清空发送记录
            this.sentMessages = []
        },
        
        async getAllList(){
            const params = {
                page: this.currentPage,
                limit: this.pageSize
            }
            
            // 添加日期范围（转换为 Unix 时间戳，单位秒）
            if (this.searchData.date && this.searchData.date.length === 2) {
                params.start_time = Math.floor(new Date(this.searchData.date[0]).getTime() / 1000)
                params.end_time = Math.floor(new Date(this.searchData.date[1]).getTime() / 1000)
            }
            
            // 添加消息类型
            if (this.searchData.msgType) {
                params.msg_type = this.searchData.msgType
            }
            
            // 添加关键词
            if (this.searchData.keyword) {
                params.keyword = this.searchData.keyword
            }
            
            let res = await this.$api.getWxMsgList(params)
            if (res ) {
                this.messageList = res.list || []
                // this.messageList = []
                
                this.total = Number(res.total) || Number(res.length) || 0
            } else {
                this.messageList = res || [] 
                this.total = res ? res.length : 0
            }
        },
        
        // 分页大小改变
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage = 1
            this.getAllList()
        },
        
        // 当前页改变
        handleCurrentChange(val) {
            this.currentPage = val
            this.getAllList()
        },
        
        // 搜索处理
        handleSearch() {
            this.currentPage = 1
            this.getAllList()
        },
        
        // 清空搜索条件
        clearSearch() {
            this.searchData = {
                date: '',
                msgType: '',
                keyword: ''
            }
            this.currentPage = 1
            this.getAllList()
        },
        
        // 根据消息类型id获取消息类型名称
        getMsgTypeName(typeId) {
            const type = this.msgTypeList.find(t => t.id === typeId)
            return type ? type.name : '未选类型'
        },

        // 获取发送状态文本
        getSendStatusText(status) {
            const statusMap = {
                0: '发送中',
                1: '已发送',
                2: '已失败',
                3: '已取消'
            }
            return statusMap[status] || '发送中'
        },

        // 获取发送状态CSS类
        getSendStatusClass(status) {
            const classMap = {
                0: 'status-sending',
                1: 'status-sent',
                2: 'status-failed',
                3: 'status-canceled'
            }
            return classMap[status] || 'status-sending'
        },
        
        // 解析文件内容
        parseFileContent(fileContent) {
            if (!fileContent) return []
            return fileContent.split(',').map(item => {
                const [url, name] = item.split('|')
                return { url, name: name || url.split('/').pop() }
            })
        },
        
        // 解析接收方数据（从 ext_data 中获取）
        parseReceivers(extData) {
            if (!extData) return []
            try {
                const data = JSON.parse(extData)
                return data.receivers || []
            } catch (e) {
                return []
            }
        },
        
        // 显示接收方信息弹窗
        showReceivers(item) {
            this.currentViewReceivers = this.parseReceivers(item.ext_data)
            this.showReceiversDialogVisible = true
        },
        
        fileDel(file,type='imgList'){
            console.log("file",file);
            
            this[type] = this[type].filter(item=>item.url!=file.response.data.url)
        
            console.log("fileList", this[type]);
        },
        
        upImgSuccess(res, file) {
            console.log("图片上传成功:", res, file);
            // 手动更新文件列表，确保上传成功的文件被正确记录
            if (res && res.data && res.data.url) {
                // 更新文件对象的 response 属性
                file.response = res;
                // 确保文件已在列表中
                const exists = this.imageFileList.some(item => item.uid === file.uid);
                if (!exists) {
                    this.imageFileList.push(file);
                }
                console.log("imageFileList:", this.imageFileList);
            }
        },
        
        upFileSuccess(res, file) {
            console.log("文件上传成功:", res, file);
            // 手动更新文件列表，确保上传成功的文件被正确记录
            if (res && res.data && res.data.url) {
                // 更新文件对象的 response 属性
                file.response = res;
                // 确保文件已在列表中
                const exists = this.fileFileList.some(item => item.uid === file.uid);
                if (!exists) {
                    this.fileFileList.push(file);
                }
                console.log("fileFileList:", this.fileFileList);
            }
        },
        
        // 获取分组列表（包含群聊数量）
        async getGroupList() {
       
            try {
                const res = await this.$api.getGroupList({})
                console.log('🔍 getGroupList API 返回:', res)
                if (res) {
                    // res 本身就是列表，直接使用
                    const groupData = Array.isArray(res) ? res : (res.data || [])
                    
                    // 获取所有已设置分组的群聊
                    const roomRes = await this.$api.getRoomList({})
                    const roomList = Array.isArray(roomRes) ? roomRes : []
                    
                    // 统计每个分组的群聊数量
                    const groupCountMap = {}
                    roomList.forEach(room => {
                        const categoryId = room.category_id
                        if (categoryId) {
                            groupCountMap[categoryId] = (groupCountMap[categoryId] || 0) + 1
                        }
                    })
                    
                    // 为每个分组添加 room_count 属性
                    this.groupList = groupData.map(group => ({
                        ...group,
                        room_count: groupCountMap[group.id] || 0
                    }))
                    
                    if (groupData.length > 0 && !this.defaultCategoryId) {
                        this.defaultCategoryId = groupData[groupData.length-1].id
                    }
                    console.log('✅ groupList 已更新:', this.groupList)
                }
                return res
            } catch (error) {
                console.error('获取分组列表失败：', error)
                return null
            }
        },
        
        // 获取父分组列表（API已包含子分组）
        async getParentCategoryList() {
            try {
                const res = await this.$api.getParentCategoryList({})
                // console.log('🔍 getParentCategoryList API 返回:', res)
                if (res) {
                    const parentData = Array.isArray(res) ? res : (res.data || [])
                    // API返回的数据已经包含children，直接使用
                    // 为每个子分组获取群聊列表
                    for (const parent of parentData) {
                        if (parent.children && parent.children.length > 0) {
                            for (const child of parent.children) {
                                child.rooms = await this.getRoomsBySubCategory(child.id)
                                child.room_count = child.rooms.length
                                
                                // 为群聊补充详细信息（头像、昵称等）
                                if (child.rooms && child.rooms.length > 0) {
                                    for (const room of child.rooms) {
                                        
                                        
                                        
                                        // 从已获取的群聊详细信息中查找
                                        const roomDetail = this.filteredGroupContacts.find(
                                            r => r.wxid === room.room_id 
                                        )
                                        
                                        if (roomDetail) {
                                            room.smallHeadImgUrl = roomDetail.small_head_img_url || roomDetail.smallHeadImgUrl
                                            room.room_name = roomDetail.remark || roomDetail.nick_name || roomDetail.nickName || room.room_name
                                        }
                                    }
                                }
                            }
                        }
                    }
                    this.parentCategoryList = parentData
                    // console.log('✅ parentCategoryList 已更新:', this.parentCategoryList)
                }
                return res
            } catch (error) {
                console.error('获取父分组列表失败：', error)
                return null
            }
        },
        
        // 根据父分组ID获取子分组
        async getChildrenByParent(parentId) {
            try {
                const res = await this.$api.getChildrenByParent({ parent_id: parentId })
                console.log('🔍 getChildrenByParent API 返回:', res)
                if (res) {
                    const childrenData = Array.isArray(res) ? res : (res.data || [])
                    // 为每个子分组获取群聊数量
                    const roomRes = await this.$api.getRoomList({})
                    const roomList = Array.isArray(roomRes) ? roomRes : []
                    
                    const groupCountMap = {}
                    roomList.forEach(room => {
                        const categoryId = room.category_id
                        if (categoryId) {
                            groupCountMap[categoryId] = (groupCountMap[categoryId] || 0) + 1
                        }
                    })
                    
                    return childrenData.map(child => ({
                        ...child,
                        room_count: groupCountMap[child.id] || 0
                    }))
                }
                return []
            } catch (error) {
                console.error('获取子分组列表失败：', error)
                return []
            }
        },
        
        // 新增父分组
        async addParentCategory(name) {
            if (!name || !name.trim()) {
                this.$erMsg('请输入父分组名称')
                return null
            }
            try {
                const res = await this.$api.saveParentCategory({ name: name.trim() })
                console.log('🔍 saveParentCategory API 返回:', res)
                if (res) {
                    this.$suMsg('父分组创建成功')
                    await this.getParentCategoryList()
                    return res
                } else {
                    this.$erMsg('父分组创建失败')
                    return null
                }
            } catch (error) {
                console.error('创建父分组失败：', error)
                this.$erMsg('父分组创建失败')
                return null
            }
        },
        
        // 删除父分组
        async removeParentCategory(parentId) {
            if (!parentId) return
            try {
                const res = await this.$api.deleteParentCategory({ id: parentId })
                if (res) {
                    this.$suMsg('父分组删除成功')
                    // 移除展开状态
                    this.expandedParentCategories = this.expandedParentCategories.filter(id => id !== parentId)
                    await this.getParentCategoryList()
                } else {
                    this.$erMsg(res.msg || '父分组删除失败')
                }
            } catch (error) {
                console.error('删除父分组失败：', error)
                this.$erMsg('删除父分组失败')
            }
        },
        
        // 删除子分组
        async deleteSubCategory(categoryId) {
            if (!categoryId) return
            try {
                const res = await this.$api.delGroup({ id: categoryId })
                if (res) {
                    this.$suMsg('子分组删除成功')
                    // 刷新父分组列表中的子分组
                    await this.getParentCategoryList()
                    // 同时刷新普通分组列表
                    await this.getGroupList()
                } else {
                    this.$erMsg(res.msg || '子分组删除失败')
                }
            } catch (error) {
                console.error('删除子分组失败：', error)
                this.$erMsg('删除子分组失败')
            }
        },
        
        // 获取子分组下的群聊列表
        async getRoomsBySubCategory(categoryId) {
            try {
                const res = await this.$api.getRoomList({ category_id: categoryId })
                if (res) {
                    return Array.isArray(res) ? res : []
                }
                return []
            } catch (error) {
                console.error('获取群聊列表失败：', error)
                return []
            }
        },
        
        // 处理父分组选择变化（级联选择）
        async handleParentCategoryChange(parentId) {
            // 如果点击已选中的大组，则取消选择
            if (this.selectedParentCategoryId === parentId) {
                this.selectedParentCategoryId = null
                this.selectedGroupId = null
                this.filteredSubCategories = []
                await this.handleGroupFilterChange(null)
                return
            }
            
            this.selectedParentCategoryId = parentId
            this.selectedGroupId = null // 重置子分组选择
            
            if (parentId) {
                // 获取该父分组下的子分组
                this.filteredSubCategories = await this.getChildrenByParent(parentId)
            }
            
            // 重置群聊选中状态
            this.selectedGroups = []
            this.selectAllGroups = false
            
            // 刷新群聊列表（只显示选中大组下的群聊）
            await this.handleGroupFilterChange(null)
        },
        
        // 创建新分组
        async createGroup(groupName) {
            if (!groupName || !groupName.trim()) {
                this.$erMsg('请输入分组名称')
                return null
            }
            try {
                const res = await this.$api.saveGroup({
                    name: groupName.trim()
                })
                console.log('🔍 createGroup API 返回:', res)
                // 直接判断 res 是否存在
                if (res) {
                    this.$suMsg('分组创建成功')
                    await this.getGroupList()
                    return res
                } else {
                    this.$erMsg('分组创建失败')
                    return null
                }
            } catch (error) {
                console.error('创建分组失败：', error)
                this.$erMsg('分组创建失败')
                return null
            }
        },
        
        // 删除分组
        async deleteGroup(groupId) {
            if (!groupId) return
            try {
                const res = await this.$api.delGroup({
                    id: groupId
                })
                if (res ) {
                    this.$suMsg('分组删除成功')
                    if (this.selectedGroupId === groupId) {
                        this.selectedGroupId = null
                    }
                    // 适配多选分组场景
                    if (Array.isArray(this.selectedGroupForMove)) {
                        this.selectedGroupForMove = this.selectedGroupForMove.filter(id => id !== groupId)
                    } else if (this.selectedGroupForMove === groupId) {
                        this.selectedGroupForMove = []
                    }
                    await this.getGroupList()
                } else {
                    this.$erMsg(res.msg || '分组删除失败')
                }
            } catch (error) {
                console.error('删除分组失败：', error)
                this.$erMsg('删除分组失败')
            }
        },
        
        // 根据分组筛选群聊
        filterGroupsByCategory(groupList, categoryId) {
            if (!categoryId) return groupList
            return groupList.filter(contact => contact.category_id === categoryId)
        },
        
        // 显示分组管理弹窗
        async openGroupManageDialog() {
            await this.getGroupList()
            this.showGroupManageDialog = true
        },
        
        // 处理新建分组
        async handleCreateGroup() {
            if (!this.newGroupName.trim()) {
                this.$erMsg('请输入分组名称')
                return
            }
            await this.createGroup(this.newGroupName)
            this.newGroupName = ''
        },
        
        // 显示移动到分组弹窗
        openMoveToGroupDialog(contacts, type) {
            this.moveTargetContacts = contacts.map(c => ({
                wxid: c.wxid,
                type: type
            }))
            this.selectedGroupForMove = this.defaultCategoryId ? [this.defaultCategoryId] : []
            this.showMoveToGroupDialog = true
        },
        
        // 确认移动到分组（支持多对多）
        async confirmMoveToGroup() {
            if (!this.moveTargetContacts.length) {
                this.$erMsg('请选择要移动的联系人')
                return
            }
            
            if (!this.selectedGroupForMove || this.selectedGroupForMove.length === 0) {
                this.$erMsg('请选择目标分组')
                return
            }
            
            try {
                // 过滤出群聊类型的联系人
                const groupContacts = this.moveTargetContacts.filter(c => c.type === 'group')
                
                if (groupContacts.length > 0) {
                    // 构建多对多关系数据
                    // 每个群聊对应每个选中的分组
                    const batchData = []
                    groupContacts.forEach(contact => {
                        this.selectedGroupForMove.forEach(categoryId => {
                            batchData.push({
                                room_id: contact.wxid,
                                category_id: categoryId,
                            })
                        })
                    })
                    
                    // 调用批量更新分组接口（多对多版）
                    await this.$api.insertRoomCategoryBatch(batchData)
                }
                
                this.$suMsg('移动成功')
                this.showMoveToGroupDialog = false
                this.moveTargetContacts = []
                this.selectedGroupForMove = []
                
                // 重新获取分组列表（更新群聊数量）
                await this.getGroupList()
                // 刷新群聊分组映射
                await this.refreshGroupContactsMapping()
            } catch (error) {
                console.error('移动分组失败：', error)
                this.$erMsg('移动分组失败')
            }
        },
        
        // 批量移动选中的群聊到指定分组
        async batchMoveGroupsToCategory() {
            const selectedGroupContacts = this.groupContacts.filter(contact => 
                this.selectedGroups.includes(contact.wxid)
            )
            
            if (selectedGroupContacts.length === 0) {
                this.$erMsg('请先选择要移动的群聊')
                return
            }
            
            await this.getGroupList()
            this.openMoveToGroupDialog(selectedGroupContacts, 'group')
        },
        // 获取消息类型列表
        async getMsgTypeList() {
            try {
                const res = await this.$api.getWxMsgTypeList({})
                if (res && res.data) {
                    this.msgTypeList = res.data
                } else {
                    this.msgTypeList = res || []
                }
            } catch (error) {
                console.error('获取消息类型列表失败:', error)
                this.msgTypeList = []
            }
        },
        
        // 切换显示新增父分组输入框
        async toggleAddParentCategory() {
            // let msgResult = await this.$apiGewe.sendMsg({
            //     toWxid: "wxid_vdcgobb4un7522",
            //     content:"下午好"
            // });
            // console.log("msgResult",msgResult);
            
            this.showAddParentCategoryInput = !this.showAddParentCategoryInput
            if (!this.showAddParentCategoryInput) {
                this.newParentCategoryName = ''
            }
        },
        // 同步微信好友信息
        async syncWechatFriends() {
            await this.$api.syncContacts()
            this.$suMsg('微信好友信息同步成功')
            location.reload()
        },
        // 确认添加父分组
        async confirmAddParentCategory() {
            await this.addParentCategory(this.newParentCategoryName)
            this.newParentCategoryName = ''
            this.showAddParentCategoryInput = false
        },
        
        // 处理父分组展开
        handleParentExpand(data) {
            if (!this.expandedParentCategories.includes(data.id)) {
                this.expandedParentCategories.push(data.id)
            }
        },
        
        // 处理父分组折叠
        handleParentCollapse(data) {
            this.expandedParentCategories = this.expandedParentCategories.filter(id => id !== data.id)
        },
        
        // 处理定时发送开关变化
        handleScheduleSendChange(val) {
            if (!val) {
                this.sendTime = ''
            }
        },
        
        // 删除群聊（从分组中移除）
        async removeRoomFromCategory(id) {
            if (!id) return
            try {
                const res = await this.$api.deleteGroupRoomById({
                    id,
                   
                })
                if (res) {
                    this.$suMsg('群聊移除成功')
                    await this.getParentCategoryList()
                } else {
                    this.$erMsg(res.msg || '群聊移除失败')
                }
            } catch (error) {
                console.error('移除群聊失败：', error)
                this.$erMsg('移除群聊失败')
            }
        },
        
        // 标签页切换处理
        handleTabClick(tab) {
            if (tab.name === 'third') {
                // 切换到分组管理标签页时刷新父分组列表
                this.getParentCategoryList()
            } else if (tab.name === 'second') {
                // 切换到消息历史时刷新列表
                this.currentPage = 1
                this.getAllList()
            }
        },
        
        // 打开添加子分组弹窗
        openAddSubCategoryDialog(parentId) {
            this.currentParentId = parentId
            const parent = this.parentCategoryList.find(p => p.id === parentId)
            this.currentParentName = parent ? parent.name : ''
            this.newSubCategoryName = ''
            this.showAddSubCategoryDialog = true
        },
        
        // 确认添加子分组
        async confirmAddSubCategory() {
            if (!this.newSubCategoryName.trim()) {
                this.$erMsg('请输入子分组名称')
                return
            }
            try {
                const res = await this.$api.saveSubCategory({
                    parent_id: this.currentParentId,
                    name: this.newSubCategoryName.trim()
                })
                if (res) {
                    this.$suMsg('子分组创建成功')
                    this.showAddSubCategoryDialog = false
                    await this.getParentCategoryList()
                } else {
                    this.$erMsg('子分组创建失败')
                }
            } catch (error) {
                console.error('创建子分组失败：', error)
                this.$erMsg('子分组创建失败')
            }
        },
        
        // 打开添加群聊到分组弹窗
        async openAddRoomToCategoryDialog(categoryId) {
            this.currentCategoryId = categoryId
            // 从父分组列表中找到对应子分组的名称
            let categoryName = ''
            for (const parent of this.parentCategoryList) {
                const child = parent.children.find(c => c.id === categoryId)
                if (child) {
                    categoryName = child.name
                    break
                }
            }
            this.currentCategoryName = categoryName
            this.selectedRoomsForAdd = []
            this.selectAllRooms = false // 重置全选状态
            this.roomSearchKeyword = '' // 清空搜索关键词
            
            // 如果尚未初始化联系人列表，先初始化
            if (!this.filteredChatrooms || this.filteredChatrooms.length === 0) {
                await this.initContactList()
            }
            
            // 获取当前分组已有的群聊
            const currentCategoryRooms = await this.getRoomsBySubCategory(categoryId)
            const currentRoomIds = currentCategoryRooms.map(r => r.room_id)
            
            // 使用已有的群聊详细信息，过滤出未添加到当前分组的群聊
            this.availableRooms = this.filteredGroupContacts.filter(room => 
                !currentRoomIds.includes(room.wxid)
            )
            
            this.showAddRoomDialog = true
        },
        
        // 处理全选群聊
        handleSelectAllRooms(checked) {
            if (checked) {
                // 全选：将所有可用群聊加入选中列表
                this.selectedRoomsForAdd = this.filteredAvailableRooms.map(room => room.wxid)
            } else {
                // 取消全选：清空选中列表
                this.selectedRoomsForAdd = []
            }
        },
        
        // 确认添加群聊到分组
        async confirmAddRoomsToCategory() {
            if (!this.selectedRoomsForAdd.length) {
                this.$erMsg('请选择要添加的群聊')
                return
            }
            
            try {
                // 构建批量添加数据
                const batchData = this.selectedRoomsForAdd.map(roomId => ({
                    room_id: roomId,
                    category_id: this.currentCategoryId
                }))
                
                // 调用批量更新接口
                await this.$api.insertRoomCategoryBatch(batchData)
                
                this.$suMsg('群聊添加成功')
                this.showAddRoomDialog = false
                await this.getParentCategoryList()
            } catch (error) {
                console.error('添加群聊失败：', error)
                this.$erMsg('群聊添加失败')
            }
        },
    },
    computed: {
        // 树形结构数据（支持三层：信息分类 -> 群分组 -> 群聊）
        parentCategoryTreeData() {
            return this.parentCategoryList.map(parent => ({
                id: 'parent_' + parent.id,
                label: parent.name,
                type: 'parent',
                originalId: parent.id,
                children: parent.children ? parent.children.map(child => ({
                    id: 'child_' + child.id,
                    label: child.name + ' (' + (child.room_count || 0) + ')',
                    type: 'child',
                    originalId: child.id,
                    children: child.rooms ? child.rooms.map(room => ({
                        id: 'room_' + room.room_id,
                        label: room.room_name || room.room_id,
                        type: 'room',
                        originalId: room.room_id,
                        children: [] // 群聊是叶子节点
                    })) : []
                })) : []
            }))
        },
        
        // 树配置
        treeProps() {
            return {
                label: 'label',
                children: 'children'
            }
        },
        
        // 过滤可用的群聊列表（根据搜索关键词）
        filteredAvailableRooms() {
            if (!this.roomSearchKeyword) {
                return this.availableRooms
            }
            const keyword = this.roomSearchKeyword.toLowerCase()
            return this.availableRooms.filter(room => {
                const name = room.remark || room.nick_name || room.nickName || room.wxid || ''
                return name.toLowerCase().includes(keyword)
            })
        }
    },
    async created(){
        this.getAllList()
        this.getMsgTypeList()
        await this.initContactList() // 先初始化联系人列表（群聊和好友）
        await this.getParentCategoryList() // 等待联系人列表初始化完成后再获取父分组
        
    },
    
    
    props:{
        
    }
}
</script>
<style lang="scss">
.my-message{
    background: #fff;
    padding: 20px;
    position: relative;
    .upload-image{
        .el-upload-dragger{
            height: 146px;
            width:  146px;
        }

    }
    // 页面内加载遮罩
    .sending-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.9);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
        
        .sending-content {
            text-align: center;
            padding: 40px;
            background: white;
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            
            .el-icon-loading {
                font-size: 32px;
                color: #409EFF;
                animation: rotating 1s linear infinite;
            }
            
            p {
                margin: 16px 0;
                font-size: 16px;
                color: #333;
            }
            
            .el-button {
                margin-top: 8px;
            }
        }
    }
    
    // 联系人选择器样式
    .contact-selector, .contact-selector-inline {
        // 大组 tag 列表样式（信息分类）
        .parent-category-tags {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            margin-bottom: 10px;
            
            .tag-item {
                display: inline-block;
                padding: 6px 14px;
                background: #f5f7fa;
                border: 1px solid #dcdfe6;
                border-radius: 4px;
                font-size: 13px;
                color: #606266;
                cursor: pointer;
                transition: all 0.3s;
                user-select: none;
                
                &:hover {
                    background: #e6f7ff;
                    border-color: #91d5ff;
                    color: #1890ff;
                }
                
                &.active {
                    background: #1890ff;
                    border-color: #1890ff;
                    color: #ffffff;
                }
            }
            
            .empty-tip {
                color: #909399;
                font-size: 13px;
                padding: 6px 0;
            }
        }
        
        .contact-list {
            max-height: 300px;
            overflow-y: auto;
            
            .contact-item {
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                padding: 5px 0;
                
                ::v-deep .el-checkbox__input {
                    line-height: 30px;
                    align-self: flex-start;
                }
                
                ::v-deep .el-checkbox__label {
                    width: 100%;
                    padding-left: 10px;
                }
                
                .contact-info {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    
                    .el-avatar {
                        flex-shrink: 0;
                    }
                    
                    .contact-name {
                        margin-left: 10px;
                        flex: 1;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        
                        .group-tag {
                            font-size: 12px;
                            color: #909399;
                            margin-left: 6px;
                            font-weight: normal;
                        }
                    }
                }
            }
        }
        
        // 确保折叠面板标题对齐
        .el-collapse-item__header {
            align-items: center;
            
            ::v-deep .el-checkbox {
                display: flex;
                align-items: center;
                height: auto;
                
                .el-checkbox__input {
                    align-self: center;
                }
                
                .el-checkbox__label {
                    padding-left: 8px;
                }
            }
        }
        
        // 确保复选框组正确对齐
        ::v-deep .el-checkbox-group {
            display: block;
        }
    }
    
    // 添加群聊到分组弹窗样式
    .add-room-to-category {
        // max-height: 400px;
        overflow-y: auto;
        
        .room-list-container {
            max-height: 350px;
            overflow-y: auto;
            padding: 5px;
        }
        
        .contact-item {
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            padding: 8px 12px;
            background: #f5f7fa;
            border-radius: 4px;
            
            ::v-deep .el-checkbox__input {
                line-height: 30px;
                vertical-align: top;
            }
            
            ::v-deep .el-checkbox__label {
                width: 100%;
                padding-left: 10px;
            }
            
            .contact-info {
                display: flex;
                align-items: center;
                gap: 10px;
                
                .el-avatar {
                    flex-shrink: 0;
                }
                
                .contact-name {
                    flex: 1;
                    font-size: 14px;
                    color: #303133;
                    word-break: break-all;
                    
                    .group-tag {
                        color: #909399;
                        font-size: 12px;
                        margin-left: 5px;
                    }
                }
            }
        }
    }
    
    // 分组管理页面样式
    .group-management-page {
        padding: 20px;
        
        .add-parent-category {
            margin-bottom: 20px;
            padding: 15px;
            background: #f5f7fa;
            border-radius: 8px;
            display: flex;
            align-items: center;
        }
        
        .add-parent-btn {
            margin-bottom: 20px;
            text-align: right;
        }
        
        .parent-category-collapse {
            .empty-tip {
                text-align: center;
                color: #999;
                padding: 40px;
            }
            
            .empty-child-tip,
            .empty-room-tip {
                text-align: center;
                color: #999;
                padding: 20px;
                font-size: 13px;
            }
            
            .collapse-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                
                .parent-name {
                    font-weight: 600;
                    color: #303133;
                }
                
                .child-name {
                    color: #606266;
                }
                
                .parent-actions,
                .child-actions {
                    display: flex;
                    margin-right: 10px;
                    gap: 4px;
                }
                
                .action-btn {
                    width: 24px;
                    height: 24px;
                    padding: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 12px;
                }
            }
            
            // 子分组缩进
            .el-collapse-item__header {
                padding-left: 30px !important;
            }
            
            // 子分组内容区域缩进
            .el-collapse-item__content {
                padding-left: 30px !important;
            }
            
            // 群聊列表缩进
            .room-list {
                padding: 10px 40px;
                
                .room-item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 8px 12px;
                    border-bottom: 1px solid #f0f0f0;
                    
                    &:last-child {
                        border-bottom: none;
                    }
                    
                    .room-name {
                        color: #909399;
                        font-size: 13px;
                    }
                    
                    .room-btn {
                        opacity: 0.6;
                        
                        &:hover {
                            opacity: 1;
                        }
                    }
                }
            }
        }
    }
    
    // 分组管理弹窗样式
    .group-manage {
        .create-group {
            margin-bottom: 15px;
        }
        
        .group-list {
            max-height: 250px;
            overflow-y: auto;
            
            .empty-tip {
                text-align: center;
                color: #999;
                padding: 20px;
            }
            
            .group-item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 12px 15px;
                margin-bottom: 8px;
                background: #fafafa;
                border-radius: 6px;
                border: 1px solid #e8e8e8;
                transition: all 0.3s ease;
                
                &:hover {
                    background: #f0f5ff;
                    border-color: #d0e7ff;
                }
                
                span {
                    flex: 1;
                    font-size: 14px;
                    color: #303133;
                }
                
                .el-button {
                    margin-left: 15px;
                }
            }
        }
    }
    
    // 移动到分组弹窗样式
    .move-to-group {
        p {
            color: #606266;
            font-size: 14px;
        }
    }
    
    .search-box {
        padding: 15px 20px;
        background: #fafafa;
        border-bottom: 1px solid #e8e8e8;
        .oe-el-input {
            width: 120px;
        }
        .small-select {
            width: 120px;
        }
        .el-date-editor {
            width: 220px;
        }
    }
    
    .his-list{
        .msg-item{
            border: 1px solid #E8E8E8;
            border-radius: 8px;
            margin: 15px;
            overflow: hidden;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
            
            .item-top{
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                padding: 12px 15px;
                background: #E9ECEF;
                border-bottom: 1px solid #DEE2E6;
                
                span{
                    margin-right: 20px;
                    font-size: 14px;
                    
                    &.serial {
                        color: #606266;
                        font-weight: 500;
                    }
                    
                    &.msg-type {
                        color: #409EFF;
                    }
                    
                    &.time {
                        color: #909399;
                    }
                    
                    &.publisher {
                        color: #606266;
                        margin-left: auto;
                    }
                    
                    &.send-status {
                        padding: 2px 8px;
                        border-radius: 4px;
                        font-size: 12px;
                        font-weight: 500;
                        
                        &.status-sending {
                            // background: #fff3cd;
                            color: #856404;
                        }
                        
                        &.status-sent {
                            // background: #d4edda;
                            color: #155724;
                        }
                        
                        &.status-failed {
                            // background: #f8d7da;
                            color: #721c24;
                        }
                        
                        &.status-canceled {
                        // 1
                            // background: #e2e3e5;
                            color: #6c757d;
                        }
                    }
                }
            }
            
            .item-body{
                padding: 15px;
                display: flex;
                align-items: center;
                
                .section-title {
                    font-size: 14px;
                    font-weight: 600;
                    color: #303133;
                    width: 80px;
                    flex-shrink: 0;
                }
                
                .content-area {
                    flex: 1;
                    margin-left: 15px;
                }
                
                .image-grid {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 10px;
                }
                
                .preview-image {
                    width: 120px;
                    height: 120px;
                    object-fit: cover;
                    border-radius: 4px;
                    cursor: pointer;
                    transition: transform 0.2s;
                    
                    &:hover {
                        transform: scale(1.05);
                    }
                }
                
                .text-content {
                    font-size: 14px;
                    color: #606266;
                    line-height: 1.8;
                    white-space: pre-wrap;
                    word-break: break-all;
                }
                
                .file-list {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 10px;
                }
                .file-link {
                    display: flex;
                    align-items: center;
                    padding: 8px 12px;
                    background: #F5F7FA;
                    border-radius: 4px;
                    color: #606266;
                    text-decoration: none;
                    font-size: 14px;
                    transition: all 0.2s;
                    
                    &:hover {
                        background: #E8F4FF;
                        color: #409EFF;
                    }
                    
                    .el-icon-document {
                        margin-right: 6px;
                        font-size: 16px;
                    }
                }
            }
            
            .item-footer {
                padding: 10px 15px;
                border-top: 1px solid #f0f0f0;
                background: #fafafa;
            }
        }
    }
    
    .pagination-container {
        padding: 20px;
        text-align: center;
        background: #fafafa;
        border-top: 1px solid #e8e8e8;
    }
}

// loading 旋转动画
@keyframes rotating {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>